export const appsAppGroupIdAnalyticsReportSettingCacheKeys = "/apps/:app_group_id/analytics_report_setting";
